import { render, staticRenderFns } from "./BeuticianLocalDataSheetsList.vue?vue&type=template&id=5acb0eca"
import script from "./BeuticianLocalDataSheetsList.vue?vue&type=script&lang=js"
export * from "./BeuticianLocalDataSheetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports